import React from "react";

import styles from "../../styles/order-details.module.scss";

export default class Observation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getSegments() {
    const { order } = this.props;

    const observation = order?.observation || "";

    const observationSegments = observation.split("//").filter(Boolean);
    return observationSegments;
  }

  render() {
    const observationSegments = this.getSegments();

    if (observationSegments.length === 0) {
      return <></>;
    }

    return (
      <div className={styles.observation}>
        <p className={styles.title}>Observação</p>
        {observationSegments.map((text) => (
          <p className={styles.text}>{text}</p>
        ))}
      </div>
    );
  }
}
